export const MAX_ITEM_HEIGHT = 136;
export const SKIP_TEXT_WIDTH = 150;
export const MARGIN_HORIZONTAL = 38; // margin to account for max size of average circle radius
export const MARGIN_BOTTOM = 20;
export const BAR_HEIGHT_FACTOR = 0.1;

export const getAverageScoreCircleRadius = (height: number) => height * 0.25;

export const MIN_PADDING = 4;
